import type { IRecord } from '@platform/core/types';
import type { ISearchWireHit, ISearchWireResult } from '@platform/dao';

/**
 * Додає до результату пошуку запис, знайдений за кодом (TSK-3): першим у групі його типу запису (групи за типом) чи модуля (нова група —
 * першою), без повтору, з перерахунком кількостей. Чиста функція.
 */
export function mergeCodeHit(result: ISearchWireResult, record: IRecord | null | undefined, workspaceId: string): ISearchWireResult {
  if (!record || result.groups.some((g) => g.hits.some((h) => h.recordId === record.id))) return result;
  const hit: ISearchWireHit = {
    recordId: record.id, workspaceId, module: record.module, recordType: record.recordType, code: record.code, display: record.display,
    title: record.title, status: record.status, highlight: null, rank: Number.MAX_SAFE_INTEGER, exact: true,
  };
  const byType = result.groups.some((g) => !!g.recordType);
  const own = result.groups.find((g) => (byType ? g.recordType === record.recordType : g.module === record.module));
  const groups = own
    ? result.groups.map((g) => (g === own ? { ...g, count: g.count + 1, hits: [hit, ...g.hits] } : g))
    : [{ module: record.module, ...(byType ? { recordType: record.recordType, key: record.recordType } : {}), count: 1, hits: [hit] }, ...result.groups];
  return { ...result, total: result.total + 1, groups };
}
